<template>
  <el-dialog :visible.sync="dialogVisible" width="500px" :show-close="false">
    <div class="modal-header">
      <span class="modal-title">{{ $t("confirmBuy.trade_password") }}</span>
    </div>

    <div class="password-section">
      <div class="password-input-wrap">
        <input
          type="password"
          v-model="tradePassword"
          class="password-input-hidden"
          maxlength="6"
          @input="handlePasswordInput"
          @focus="handleInputFocus"
        />
        <div class="password-boxes">
          <div v-for="(item, index) in 6" :key="index" class="password-box">
            <span class="password-char">{{ getPasswordChar(index) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="submit-btn" @click="handleConfirm">
        {{ $t("confirmBuy.confirm_pay") }}
      </button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PasswordDialog",
  props: {
    orderNo: {
      type: String,
      default: "",
    },
    payAssetType: {
      type: String,
      default: "USD",
    },
  },
  data() {
    return {
      dialogVisible: false,
      tradePassword: "",
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.tradePassword = "";
    },
    getPasswordChar(index) {
      if (this.tradePassword && this.tradePassword.length > index) {
        return "●";
      }
      return "";
    },
    handlePasswordInput() {
      if (this.tradePassword.length === 6) {
        this.handleConfirm();
      }
    },
    handleInputFocus() {},
    async handleConfirm() {
      if (!this.tradePassword || this.tradePassword.length < 6) {
        this.$message.warning(this.$t("confirmBuy.enter_password"));
        return;
      }

      const loadingInstance = this.$loading({
        text: this.$t("confirmBuy.processing"),
      });

      try {
        const payRes = await this.$axios.post("/mall/order/pay", {
          orderNo: this.orderNo,
          payAssetType: this.payAssetType,
          tranPwd: this.tradePassword,
        });

        loadingInstance.close();

        if (payRes.data.code === this.errorCode.ok) {
          this.tradePassword = "";
          this.dialogVisible = false;
          this.$emit("success", { orderNo: this.orderNo });
        } else {
          this.$message.error(
            payRes.data.msg || this.$t("confirmBuy.pay_fail"),
          );
        }
      } catch (error) {
        loadingInstance.close();
        this.$message.error(this.$t("confirmBuy.pay_fail"));
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 12px;
  .el-dialog__body {
    padding-top: 0;
    position: relative;
    padding: 30px;
  }
}

.modal-header {
  text-align: center;
  margin-bottom: 30px;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.password-section {
  margin-bottom: 30px;
}

.password-input-wrap {
  position: relative;
}

.password-input-hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.password-boxes {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.password-box {
  width: 50px;
  height: 56px;
  background-color: #f9f9f9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e8e8e8;
}

.password-char {
  font-size: 24px;
  color: #333333;
}

.modal-footer {
  .submit-btn {
    width: 100%;
    height: 48px;
    background: linear-gradient(135deg, #4063ff 0%, #6b8cff 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    border: none;
    cursor: pointer;

    &:hover {
      background: linear-gradient(135deg, #3053ee 0%, #5a7cff 100%);
    }
  }
}
</style>
